import { styled } from '@mui/material';

const StyledFileName = styled('span')`
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export default StyledFileName;
